"use client";

import React from "react";
import { ArrowUpRight } from "lucide-react";
export default function Guide() {
  return <section id="tireselectionguide" data-nav="light" className="relative bg-[#F4F5F7] text-[#101D30] py-8 md:py-10">
  <div aria-hidden="true" className="absolute top-0 inset-x-0 h-[2px] bg-gradient-to-r from-[#FF5A00] via-[#0B4DBA] to-[#0B4DBA]/10" />
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
   <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 pb-6 border-b border-[#CFD5DD]">
    <div><p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#667080] mb-2">Nova Tire Center · Los Angeles</p><h2 className="text-[28px] sm:text-[34px] leading-tight font-black italic uppercase tracking-tight">The right tires.<br className="sm:hidden" /> <span className="text-[#0B4DBA] inline-block">The right fit.</span></h2></div>
    <p className="text-sm leading-relaxed text-[#505C6C] max-w-md">Find tires for your vehicle and budget at our tire shop on Pico Blvd.</p>
   </div>
   <div className="grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-6 py-2 md:py-5">
    {[{
          n: "01",
          title: "Matched to your vehicle",
          text: "The correct size, load rating and tire type for your car."
        }, {
          n: "02",
          title: "Options within your budget",
          text: "Compare suitable tires for your driving needs and price range."
        }, {
          n: "03",
          title: "Availability, confirmed",
          text: "Get current stock, timing and the full installed price before you visit."
        }].map((item, i) => <div key={item.n} className={"flex gap-3 py-4 md:py-2 " + (i < 2 ? "border-b md:border-b-0 md:border-r border-[#D8DDE4] md:pr-5" : "")}>
      <span className="text-[11px] font-bold text-[#0B4DBA] pt-1">{item.n}</span>
      <div><h3 className="text-base font-bold mb-1.5">{item.title}</h3><p className="text-sm leading-relaxed text-[#505C6C]">{item.text}</p></div>
     </div>)}
   </div>
   <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 pt-3">
    <p className="text-xs text-[#596475]">Have your tire size handy? We can check your options. Not sure? We can help.</p>
    <a href="tel:+14243138474" className="inline-flex items-center gap-2 text-sm font-bold text-[#0B4DBA] hover:underline py-2 shrink-0">Check tires & pricing <ArrowUpRight className="w-4 h-4" /></a>
   </div>
  </div>
 </section>;
}